var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5625C9.93198 9.5625 10.6875 8.80698 10.6875 7.875C10.6875 6.94302 9.93198 6.1875 9 6.1875C8.06802 6.1875 7.3125 6.94302 7.3125 7.875C7.3125 8.80698 8.06802 9.5625 9 9.5625Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8124 7.87512C14.8124 4.66512 12.2099 2.06262 8.99988 2.06262C5.78988 2.06262 3.18738 4.66512 3.18738 7.87512C3.18738 9.3155 3.71425 10.631 4.582 11.6465C4.582 11.6465 7.3405 14.7826 8.22513 15.6267C8.65975 16.0411 9.33925 16.0411 9.77388 15.6267C10.8048 14.6435 13.417 11.6465 13.417 11.6465C14.2855 10.631 14.8124 9.3155 14.8124 7.87512Z",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f9d016c0f0a96969cab1339d0b2ac065.svg";
export { ForwardRef as ReactComponent };